<template>
  <div
    class="video-container"
    :class="device.isMobile ? 'video-container-mobile' : ''"
    :id="content.key"
  >
    <styleType1 v-if="styleType === 1" contentType="video" :content="content" @dialogOpen="dialogVisible = true"></styleType1>
    <div class="video-box" v-else>
      <img class="video-top" :src="content.top_img || topBg" />
      <div class="video-content">
        <img class="video-cover" :src="content.left_img || leftBg" alt="">
        <div class="video-title">
          <div class="video-title-text video-subtitle" v-if="content.subtitle">{{ content.subtitle }}</div>
          <div class="video-title-text">{{ content.title }}</div>
        </div>
        <div class="play-btn" @click.stop="videoPlayerShow"></div>
      </div>
    </div>
    <videoPlayer :dialogTitle="dialogTitle" :visible="dialogVisible" :video_src="content.url" @dialogClose="videoPlayerHide"></videoPlayer>
  </div>
  
  <!-- <div :id="content.key" class="special-module content_w_710">
    <img :id="`${content.key}-1`" :src="content.top_img" />
    <div :id="`${content.key}-2`" class="special-module-content">
      <div class="content-back" :style="`background-image: url(${content.left_img});`"></div>
      <textIndex class="content" v-for="item in content.content" :key="item.key" :content="item" :isInTable="true"></textIndex>
    </div>
  </div> -->
</template>

<script>
/*
单个视频样式 适用于单个显示版型
*/
import videoPlayer from "../../popup/videoPlayer.vue";
import styleType1 from "../style/style-1.vue";
export default {
  name: "videoUnit",
  components: {
    videoPlayer,
    styleType1,
  },
  props: {
    content: {
      type: Object,
      default: () => {
        return {};
      }
    },
    styleType: {
      type: Number,
      default: 0
    },
  },
  data() {
    return {
      dialogTitle: '播放视频',
      dialogVisible: false,
      topBg: require("@/assets/images/books/bookExample/block-top-bg.png"),
      leftBg: require("@/assets/images/books/bookExample/video-left.png"),
    }
  },
  methods: {
    videoPlayerShow() {
      this.dialogVisible = true
    },
    videoPlayerHide() {
      this.dialogVisible = false
    },
  }
}
</script>

<style lang="scss" scoped>
.video-container {
  width: 100%;
  margin: 30rem auto;

  .video-box{
    width: 100%;
    position: relative;

    .video-top{
      display: block;
      width: 100%;
    }

    .video-content{
      width: 100%;
      height: 150rem;
      background: rgba(255,255,255,0.7);
      box-shadow: 0rem 3rem 16rem 0rem rgba(32,37,36,0.1);
      border: 1rem solid #4B96D1;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .video-cover{
        display: block;
        width: 80rem;
        max-height: 126rem;
        margin-left: 34rem;
      }
  
      .video-title{
        flex: 1;
        padding: 0 15rem;
        margin-bottom: 30rem;
    
        .video-title-text {
          font-size: 20rem;
          font-weight: bold;
        }
        .video-title-text.video-subtitle {
          font-size: 16rem;
          color: #666;
          font-weight: normal;
        }
      }
  
      .play-btn{
        width: 88rem;
        height: 88rem;
        margin-right: 26rem;
        background: url(~@/assets/images/books/bookExample/video-play.png) center center no-repeat;
        background-size: contain;
        cursor: pointer;
      }
    }
  }
}

.video-container-mobile{
  margin: 45rem auto 55rem;

  .video-box{
    .video-content{
      .video-title{
        .video-title-text {
          font-size: 28rem;
        }
        .video-title-text.video-subtitle {
          font-size: 20rem;
        }
      }
    }
  }
}
</style>